/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [headline-user-entry.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 28.02.20, 21:32
 */
import he from 'he';

import React, {useEffect, useRef, useState} from 'react';
import {HeadlineTitle2} from "../navigation/links/nav-headlines";
import SimpleBarScroller from "../scrollbars/simple-bar-scroller";
import {cn} from "../util/text-utils";

// using simplebar-scroller because smooth-scrollbar not working as expected here s. toggler
// component displays content as html
const HtmlTextToggler = ({title, text, icon, fullview, active, visible = false, className, ...otherProps}) => {
    const refElem = useRef(null);
    const [isVisible, setIsVisible] = useState(visible);

    // make sure only allowed non-dangerous html displayed
    useEffect(() => {
        if (refElem.current) {
            refElem.current.innerHTML = he.decode(refElem.current.innerHTML);
        }
    }, [isVisible]);

    const toggle = (event) => {
        event.preventDefault();
        const isVisible = refElem.current.classList.toggle('active-show');
        setIsVisible(isVisible);
    };

    if (!text) return '';

    return <div className="headline-entry">
        <HeadlineTitle2 title={title} onClick={toggle} icon={icon} open={visible} {...otherProps} />
        <div className={cn('headline-text-toggle', [active, 'active-show'], [className])}
             ref={refElem}>
            <SimpleBarScroller className='headline-user-toggler'>
                {text}
            </SimpleBarScroller>
        </div>
    </div>;
}

export default HtmlTextToggler;